import { fetchImprovements as fetchImprovementsCall } from 'repositories/amorc.repository';

/**
 * Action types
 */
export const FETCHING_IMPROVEMENTS = 'FETCHING_IMPROVEMENTS';
export const FETCHED_IMPROVEMENTS = 'FETCHED_IMPROVEMENTS';

/**
 * Action Creators
 */
const fetchingImprovements = () => ({
  type: FETCHING_IMPROVEMENTS,
  payload: null,
});

const fetchedImprovements = (response) => ({
  type: FETCHED_IMPROVEMENTS,
  payload: response,
});

/**
  * Método utilizado para buscar os aperfeiçoamentos
  * (Formação, Ocupação e Especialização)
  * @param {Attributes of improvements} params
  */
export const fetchImprovements = (params) => (dispatch) => {
  dispatch(fetchingImprovements());
  return fetchImprovementsCall(params)
    .then((res) => dispatch(fetchedImprovements(res.data.data)));
};
